import React, { FC } from 'react'
import i18n from 'i18next'
import { format } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  levelInfo: any[];
}

const LevelTable: FC<IProps> = (props: IProps) => {
  const { levelInfo } = props
  return (
    <table className='mkt-level-table'>
      <thead>
        <tr>
          <th></th>
          <th>{i18n.t('mkt.giftCard.cardName')}</th>
          <th>{i18n.t('mkt.giftCard.discount')}</th>
          <th>{i18n.t('mkt.member.growthValue')}</th>
          <th>{i18n.t('mkt.member.growthValueGet')}</th>
        </tr>
      </thead>
      <tbody>
        {
          levelInfo.map((item: any, index: number) => {
            return (
              <tr key={index}>
                <td>LV{index + 1}</td>
                <td>{item.cardName}</td>
                <td>
                  <div>{item?.products?.length ? i18n.t('mkt.member.someMeals') : i18n.t('order.meals')}{item.discountType ? item.discountType === 'memberPrice' ? i18n.t('checkout.memberPrice') : format.toDiscount('discountRate', item.discountValue) : i18n.t('mkt.member.noDiscount')}</div>
                  <div>
                    {item?.mallProducts?.length ? i18n.t('mkt.member.someMall') : i18n.t('order.mall')}
                    {item.mallDiscountType === null && i18n.t('mkt.member.noDiscount')}
                    {item.mallDiscountType === 'memberPrice' && i18n.t('checkout.memberPrice')}
                    {item.mallDiscountType === 'discountRate' && format.toDiscount('discountRate', item.mallDiscountValue)}
                  </div>
                </td>
                <td>{item.levelGrowth || 0}</td>
                {index === 0 &&
                  <td rowSpan={levelInfo.length}>
                    {
                      !!item.mallGrowthGet || !!item.consumeGrowthGet || !!item.rechargeGrowthGet ? (
                        <>
                          <div>{!!item.mallGrowthGet && i18n.t('mkt.member.mallConsumeGrowth', { amount: item.mallGrowth, num: item.mallGrowthGet })}</div>
                          <div>{!!item.consumeGrowthGet && i18n.t('mkt.member.mealConsumeGrowth', { amount: item.consumeGrowth, num: item.consumeGrowthGet })}</div>
                          <div>{!!item.rechargeGrowthGet && i18n.t('mkt.member.mealRecharge', { amount: item.rechargeGrowth, num: item.rechargeGrowthGet })}</div>
                        </>) : (<div>{i18n.t('mkt.common.notEnabled')}</div>)
                    }
                  </td>}
              </tr>)
          })
        }
      </tbody>
    </table>
  )
}
export default LevelTable
